export default __webpack_public_path__ + "5ac458fb8a3e3fa50e7328a854fdb67f.png";